// This pulls in values defined in /.deploy/.env.XXX, set by the build scripts. See README.md for details
// Everything is pulled in via string, you must convert to bool/number as needed here
const Config = {
  ENV: process.env.REACT_APP_ENV,
  VERSION_STRING: process.env.REACT_APP_VERSION_STRING,
  API_URL: process.env.REACT_APP_API_URL,
  WEBSOCKET_PATH: process.env.REACT_APP_WEBSOCKET_PATH,
  IS_TRAINER_APP: process.env.REACT_APP_IS_TRAINER_APP === 'true',
  IS_CLIENT_APP: process.env.REACT_APP_IS_CLIENT_APP === 'true',
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  FETCH_CACHE_MAX_AGE_SECS: parseInt(
    process.env.REACT_APP_FETCH_CACHE_MAX_AGE_SECS,
    10,
  ),
  LOCAL_STORAGE_AUTH_KEY: process.env.REACT_APP_LOCAL_STORAGE_AUTH_KEY,
  FOOD_PHOTO_BUCKET: process.env.REACT_APP_FOOD_PHOTO_BUCKET,
  PROGRESS_PHOTO_BUCKET: process.env.REACT_APP_PROGRESS_PHOTO_BUCKET,
  CHAT_PHOTO_BUCKET: process.env.REACT_APP_CHAT_PHOTO_BUCKET,
  TRAINER_PHOTO_BUCKET: process.env.REACT_APP_TRAINER_PHOTO_BUCKET,
  ALARM_SLACK_ALERT_URL: process.env.REACT_APP_ALARM_SLACK_ALERT_URL,
  ALARM_FETCH_RESPONSE_MAX_TIME_MS: parseInt(
    process.env.REACT_APP_ALARM_FETCH_RESPONSE_MAX_TIME_MS,
    10,
  ),
  TEST_SLACK_ALERT_URL: process.env.REACT_APP_TEST_SLACK_ALERT_URL,
  GA_TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID,
  MY_CLIENTS_HEAVY_DAYS_BACK: process.env.REACT_APP_MY_CLIENTS_HEAVY_DAYS_BACK,
};

export default Config;
